import { sdkRequest } from '@eventbrite/http';
import { formatUrl } from 'url-lib';
/*
Summary of the endpoints needed for interacting wtih collections on the user profile page.
*/

export const getFollowedCollections = (userId, continuation) =>
    sdkRequest(
        formatUrl(
            `/api/v3/destination/users/${userId}/following/collections/`,
            {
                continuation,
                'expand.collection': ['image_large', 'follow_status'],
            },
        ),
    );

export const getCollectionsForPlace = (placeId, continuation) =>
    sdkRequest(
        formatUrl(
            `/api/v3/destination/collections/${placeId}/editorial-collections/`,
            {
                continuation,
                'expand.collection': ['image_large', 'follow_status'],
            },
        ),
    );

export const getCollectionsForOnline = (continuation) =>
    sdkRequest(
        formatUrl('/api/v3/destination/collections/?is_online=true', {
            continuation,
            'expand.collection': ['image_large', 'follow_status'],
        }),
    );

export const getCollectionEvents = ({
    collectionId,
    continuation,
    filter,
    secret,
    pageSize = 20,
}) =>
    sdkRequest(
        formatUrl(`/api/v3/destination/collections/${collectionId}/events/`, {
            'expand.destination_event': [
                'primary_venue',
                'image',
                'ticket_availability',
                'saves',
                'my_collections',
            ],
            dates: filter,
            page_size: pageSize,
            continuation,
            secret,
        }),
    );

export const followCollectionUrl = (id) =>
    `/api/v3/destination/collections/${id}/follow/`;
export const unfollowCollectionUrl = (id) =>
    `/api/v3/destination/collections/${id}/unfollow/`;

export const followCollection = (collectionId) =>
    sdkRequest(followCollectionUrl(collectionId), { method: 'POST' });
export const unfollowCollection = (collectionId) =>
    sdkRequest(unfollowCollectionUrl(collectionId), { method: 'POST' });
